import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, Routes } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { GoogleMapsModule } from '@angular/google-maps';

// Third-party modules
import { CountUpModule } from 'ngx-countup';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Reactive Forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';

// CDK
import { DatePipe } from '@angular/common';
import {
  AppService,
  authInterceptor,
  AuthService,
  CheckoutService,
  LandingPagesService,
  OrdersService,
  PosService,
  SeoService,
  SlidesService,
  UserService,
  VisualsService,
} from '@sifca-monorepo/clients';
import { ToastrModule } from 'ngx-toastr';
import { Meta, provideClientHydration, Title } from '@angular/platform-browser';
import { QuillModule } from 'ngx-quill';
import { CountdownModule } from 'ngx-countdown';
import { MatDialogModule } from '@angular/material/dialog';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { register } from 'swiper/element/bundle';
register();
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./components/privacy/privacy.component').then((m) => m.PrivacyComponent),
  },
  { path: 'code', loadComponent: () => import('./components/scan/scan.page').then(m => m.ScanPage) },
  { path: 'gen', loadComponent: () => import('./components/scan/generate.page').then(m => m.ScanPage) },
  { path: '**', redirectTo: 'home' },
];

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: 'ACCESS_TOKEN', useValue: 'token' },
    provideClientHydration(),
    provideHttpClient(),
    provideAnimations(),
    provideRouter(routes),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      ToastrModule.forRoot({
        timeOut: 2000,
        progressBar: false,
        enableHtml: true,
      }),
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(
      FormsModule,
      QuillModule,
      CountUpModule,
      CarouselModule,
      CountdownModule,
      TranslateModule,
      MatDialogModule,
      ReactiveFormsModule,
      GoogleMapsModule,
      SwiperModule,
    ),
    Meta,
    Title,
    DatePipe,
    SeoService,
    AppService,
    PosService,
    UserService,
    AuthService,
    SlidesService,
    OrdersService,
    VisualsService,
    CheckoutService,
    LandingPagesService,
  ],
};
